<script lang="tsx">
import { statusProps } from './props'
import { createNamespace } from '@bd/vue3-utils'
import { defineComponent } from 'vue'
const [name, bem] = createNamespace('CommonStatus')
export default defineComponent({
  name,
  props: statusProps,
  setup(props, ctx) {
    return () => (
      <div class={bem([props.type])}>
        {props.type === 'loading' ? <img src='/img/loading.png' /> : ''}
        {ctx?.slots?.default?.()}
      </div>
    )
  }
})
</script>

<style lang="less">
.common-status {
  @keyframes loading-circle {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }
  @keyframes dot {
    0% {
      opacity: 0.6;
      transform: translateY(-50%) scale(0.8);
    }

    to {
      opacity: 0;
      transform: translateY(-50%) scale(1.5);
    }
  }
  display: inline-flex;
  align-items: center;
  padding-left: 16px;
  position: relative;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;

  &::before,
  &::after {
    position: absolute;
    top: 50%;
    left: 0;
    border-radius: 50%;
    content: '';
    transform: translateY(-50%) scale(0.8);
  }

  &::before {
    width: 8px;
    height: 8px;
    animation: dot 1.2s ease-in-out infinite;
  }

  &::after {
    width: 4px;
    height: 4px;
    left: 2px;
    animation: dot 1.2s ease-in-out infinite;
    animation-delay: 0.6s;
  }

  &--loading {
    padding-left: 0;
    color: @primary-color;

    &::before,
    &::after {
      display: none;
    }

    img {
      height: 14px;
      margin-right: 8px;
      animation: loading-circle 1s infinite linear;
    }
  }

  &--success {
    color: @success-color;

    &::before,
    &::after {
      background: @success-color;
    }
  }

  &--processing {
    color: @primary-color;

    &::before,
    &::after {
      background: @primary-color;
    }
  }

  &--error {
    color: @error-color;

    &::before,
    &::after {
      background: @error-color;
    }
  }

  &--warning {
    color: @warning-color;

    &::before,
    &::after {
      background: @warning-color;
    }
  }

  &--primary {
    color: @primary-color;

    &::before,
    &::after {
      background: @primary-color;
    }
  }
}
</style>
